import React, {Component, Fragment, PureComponent} from 'react';

import {ListView, Button, Toast, Modal, Flex, WhiteSpace} from 'antd-mobile';
import {connect} from 'react-redux';
import {getOrderList, refund} from './store/actionCreators';
import {formatDate} from '../../utils/common';
import history from './../../utils/history';
import "./index.scss"
import PublicHeader from './../../components/header/index';

let pageIndex = 0;
const alert = Modal.alert;


class MyOrder extends PureComponent {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
        };
    }

    componentDidMount() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }

        this.props.getOrderList(pageIndex);

        setTimeout(() => {
            this.setState({
                isLoading: false,
            });
        }, 600);
    }

    async refund(orderId) {
        console.log(orderId)
        const data = {
            orderId: orderId,
        };
        const result = await this.props.refund(data);
        if (result.data.success === false) {
            Toast.info(result.data.error);
        } else {
            Toast.info("退款成功！");
        }
        window.location.reload();
        return result;
    }

    onEndReached = (event) => {
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        const {orderList} = this.props;
        const {data = [{}], total} = orderList;

        if (data.length >= total) {
            this.setState({hasMore: false});
        } else {
            setTimeout(() => {
                this.setState({hasMore: false}, () => {
                    this.currentPage = ++this.currentPage;
                    this.props.getOrderList(++pageIndex).then(() => {
                        this.setState({hasMore: true});
                    });
                });
            }, 200);
        }
    }


    render() {
        const {orderList} = this.props;
        const {data = [{}]} = orderList;

        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED',
                    borderBottom: '1px solid #ECECED',
                }}
            />
        );
        const renderRow = (rowData, rowID) => {
            if (JSON.stringify(rowData) == "{}") {
                return (<div>
                    <div className="user-recharge" style={{textAlign: "center", padding: "15px", color: "#888"}}>
                        暂无预约信息
                    </div>
                </div>);
            }
            const obj = rowData;
            const {siteDTO = {}, venueDTO = {}} = obj;
            return (
                <div key={rowID} style={{padding: '0 15px'}}>
                    <div className="div-header">
                        <span>{venueDTO.name}</span>
                        <span style={{
                            color: '#888',
                            fontSize: "13px",
                            float: "right"
                        }}>{formatDate(obj.createTime)}</span>
                    </div>

                    <Flex style={{display: 'flex', padding: '15px 0'}}>
                        <Flex.Item className="inline order-inline">
                            <p style={{marginBottom: '8px', fontWeight: 'bold'}}>
                                {siteDTO.name}
                            </p>
                            <p>{formatDate(obj.beginTime, 'yyyy-MM-dd')}</p>
                            <p>
                                <span>{formatDate(obj.beginTime, 'HH:mm:ss')}</span>
                                <span>-</span>
                                <span style={{marginLeft: "5px"}}>{formatDate(obj.endTime, 'HH:mm:ss')}</span>
                            </p>
                        </Flex.Item>
                        <Flex.Item className="inline" style={{flex: "none"}}>
                            <div style={{marginTop: "10px", lineHeight: "10px", color: '#FF6E27',}}>
                                {obj.status === 1 && "待支付"}
                                {obj.status === 2 && "已支付"}
                                {obj.status === 3 && "已取消"}
                                {obj.status === 4 && "已开场"}
                                {obj.status === 5 && "开场结束"}
                                {obj.status === 6 && "已退款"}
                            </div>
                        </Flex.Item>
                    </Flex>
                    <div className="div-footer">
                        <div style={{float: "left"}}>共计：{obj.price / 100}元</div>
                        {
                            obj.status == 1 ? (
                                <Button
                                    onClick={() => {
                                        history.push("/orderDetail", {orderId: obj.id, price: obj.price / 100});
                                    }}
                                    className="order-btn"
                                >
                                    去支付</Button>) : ""
                        }
                        {
                            obj.refund ? (
                                <Button
                                    onClick={() => {
                                        alert('取消预定', '确认要取消预定吗？', [
                                            {text: '取消', onPress: () => console.log('cancel')},
                                            {text: '确认', onPress: () => this.refund(obj.id)},
                                        ])
                                    }}
                                    className="order-btn"
                                >
                                    取消预定</Button>) : ""
                        }
                    </div>
                </div>
            );
        };

        return (
            <Fragment>
                <PublicHeader title="我的预约"/>

                <WhiteSpace size="sm" style={{background: "#F5F5F9"}}/>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource.cloneWithRows(data)}
                    renderFooter={() => (<div style={{padding: 30, textAlign: 'center'}}>
                        {this.state.isLoading ? '加载中...' : '已经到底啦～'}
                    </div>)}
                    renderRow={(rowData, id1, i) => renderRow(rowData, i)}
                    renderSeparator={separator}
                    className="order-list"
                    pageSize={4}
                    useBodyScroll
                    onScroll={() => {
                        console.log('scroll');
                    }}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = (data) => {
    return {
        orderList: data.orderList.orderList
    }
};

const mapDispatchToProps = (dispatch) => ({
    getOrderList: (pageIndex) => dispatch(getOrderList({pageNo: pageIndex, size: 20})),
    refund: (data) => dispatch(refund(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(MyOrder);
